var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M918 764L918 792",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 918.5,
    cy: 759.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M913.987 759.19C913.987 755.283 917.288 752.117 921.358 752.117C921.943 752.117 922.511 752.184 923.056 752.308C921.742 751.48 920.187 751 918.519 751C913.814 751 910 754.806 910 759.5C910 764.194 913.814 768 918.519 768C920.814 768 922.895 767.093 924.427 765.62C923.492 766.032 922.454 766.263 921.358 766.263C917.288 766.263 913.987 763.096 913.987 759.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M927.402 758.6L927.37 756.146L925.535 757.719L923.304 757.056L924.112 759.337L922.765 761.381L925.1 761.218L926.499 763.144L927.133 760.763L929.345 759.909L927.402 758.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.fa3d5b70122c2d6f36840422bbf74704.svg";
export { ForwardRef as ReactComponent };